import React from "react";
import { HiOutlineTag, HiX } from "react-icons/hi";
import NoTranslate from "../../../atoms/NoTranslate";
import { TodoBadge } from "../../../../types/TodoTypes";
import { badgePillStyle } from "./todoBadges";

interface Props {
  badge: TodoBadge;
  size?: "sm" | "md";
  onRemove?: () => void;
  removeLabel?: string;
}

const BadgePill: React.FC<Props> = ({
  badge,
  size = "md",
  onRemove,
  removeLabel,
}) => {
  const sm = size === "sm";
  return (
    <span
      style={badgePillStyle(badge.color)}
      className={`inline-flex items-center rounded-full border font-medium ${
        sm ? "gap-0.5 px-1.5 py-0.5" : "gap-1 px-2 py-0.5"
      } text-xs`}
    >
      <HiOutlineTag size={sm ? 10 : 12} className="flex-shrink-0 opacity-80" />
      <NoTranslate>{badge.label}</NoTranslate>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-0.5 opacity-70 hover:opacity-100"
          aria-label={removeLabel}
        >
          <HiX size={sm ? 10 : 12} />
        </button>
      )}
    </span>
  );
};

export default BadgePill;
